import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "@components/ProtectedRoute";
import { AppLayout } from "@components/Layout";
import Welcome from "@pages/Welcome";
import PreviewPage from "@pages/PreviewPage";
import Dashboard from "@pages/Dashboard";
import Upload from "@pages/Upload";
import ImageDetails from "@pages/ImageDetails";
import KeyVault from "@pages/KeyVault";
import Quarantine from "@pages/Quarantine";
import Trash from "@pages/Trash";
import Account from "@pages/Account";
import Help from "@pages/Help";
import SetupDiagnostics from "@pages/SetupDiagnostics";
import SetupKeys from "@pages/SetupKeys";
import ImportKeys from "@pages/ImportKeys";
import { routes } from "@/constants/routes";

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: routes.home, element: <Welcome /> },
      { path: "/preview", element: <PreviewPage /> },
      { path: routes.importKeys, element: <ImportKeys /> },
      {
        element: <ProtectedRoute />,
        children: [
          { path: routes.setupDiagnostics, element: <SetupDiagnostics /> },
          { path: routes.setupKeys, element: <SetupKeys /> },
          { path: routes.dashboard, element: <Dashboard /> },
          { path: routes.upload, element: <Upload /> },
          { path: routes.image(":id"), element: <ImageDetails /> },
          { path: routes.keys, element: <KeyVault /> },
          { path: routes.quarantine, element: <Quarantine /> },
          { path: routes.trash, element: <Trash /> },
          { path: routes.account, element: <Account /> },
          { path: routes.help, element: <Help /> },
        ],
      },
    ],
  },
]);
